// @flow
import React, { useEffect, useState } from 'react';
import Box from "@mui/material/Box";
import { withPermissionHOC } from "../../../permission/components/permissionHOC/permissionHOC";
import { useTranslation } from "react-i18next";
import { useParams, useLocation } from "react-router-dom";
import useUserData from "../../../../hooks/user/useUserData";
import axios from "axios";
import { API } from "../../../../helpers/constants";
import LoansDetails from "../../components/loansDetails/loansDetails";
import Documents from './documents.js'
import PropertySearch from './propertySearch.js'
import Updates from './updates.js'
import NotificationsIcon from "../../../../assets/images/icons/notificationIcon";
import {
	Typography,
	useMediaQuery,
	Tabs, Tab, Badge
} from "@mui/material";

import { LOANS } from "../../locales/namespaces";
import { enqueueSnackbar } from "notistack";
import { handleAxiosErrors, logoutUnauthorizedUser } from "../../../../helpers/errorHandling";
import useUserAction from "../../../../hooks/user/useUserAction";
import { mapLoan } from "../../types/map";
import { useDispatch, useSelector } from 'react-redux';
import { SHOW_LOADER, HIDE_LOADER } from '../../../../actions/types';


const Details = () => {
	const { t } = useTranslation(LOANS)
	const [loading, setLoading] = useState(false)
	const { id } = useParams()
	const [loanDetails, setLoanDetails] = useState({})
	const [loansDocuments, setLoansDocuments] = useState([])
	const [status, setStatus] = useState([])
	const [loanNotes, setLoanNotes] = useState([])
	const [questionnaire, setQuestionnaire] = useState([])
	const [updateDocuments, setUpdateDocuments] = useState(false)
	const { token, isLoggedIn } = useUserData()
	const { userLogout } = useUserAction()
	const matchDownSM = useMediaQuery((theme) => theme.breakpoints.down('sm'));
	const handleUpdateDocuments = (updateDocuments) => setUpdateDocuments(updateDocuments)
	const dispatch = useDispatch();

	const [value, setValue] = React.useState(0);

	const location = useLocation();
	const params = new URLSearchParams(location.search);
	const from = params.get("from");

	const handleChange = (event, newValue) => {
		setValue(newValue);
	};

	useEffect(() => {
		if (from === "notification") {
			setValue(1);
		}
	}, [from]);

	useEffect(() => {
		document.title = t('IMS Financial Consulting | Loans Details')
	}, [t])

	useEffect(() => {
		dispatch({ type: SHOW_LOADER });
		axios({
			method: 'post',
			data: { LoanId: id },
			headers: { 'Content-Type': 'application/json', 'Authorization': `Bearer ${token}` },
			url: `${API}/loan/details/data`,
		}).then(response => {
			const data = response.data
			const loan = data.loan
			setLoanDetails(mapLoan(loan))
			setStatus(data.status.map(status => ({
				...status,
				DescriptionEn: status.DescriptionEn /*&& toCamelCase(status.DescriptionEn)*/,
				DescriptionEl: status.DescriptionEl /*&& toCamelCase(status.DescriptionEl)*/
			})))
			setLoansDocuments(loan.Documents)
			setLoanNotes(loan.Notes)
			setQuestionnaire(loan.questionnaire)
			dispatch({ type: HIDE_LOADER });
		}).catch(error => {
			dispatch({ type: HIDE_LOADER });
			enqueueSnackbar(handleAxiosErrors(error, t('Failed to get loan details.')), {
				variant: 'error'
			}
			)
			logoutUnauthorizedUser(error, isLoggedIn, userLogout)
		})
	}, [updateDocuments, id])

	return (
		<Box>
			<Box sx={{ width: '100%' }}>
				<Tabs
					value={value}
					onChange={handleChange}
					className='nav-bar color-default nav-tab-loans-details'
					overflow={matchDownSM ? 'auto' : 'hidden'}
					sx={{
						borderBottom: '0.6px solid #DAE0F0',
						margin: '34px 0 0 0',
						'.MuiTabs-scroller':{
							overflow: 'auto !important',
						},
						'.MuiButtonBase-root': {
							borderBottom: '5px solid transparent',
						},
						'.MuiButtonBase-root:hover': {
							color: '#485476 !important',
						},
						'.MuiTabs-indicator': {
							display: 'none'
						},
						'.Mui-selected': {
							color: '#0BC1B6 !important',
							backgroundColor: '#fff',
							fontWeight: '700',
							borderBottom: '2px solid #0BC1B6',
							borderTopLeftRadius: '8px',
							borderTopRightRadius: '8px',
							borderBottomLeftRadius: 'inherit',
							borderBottomRightRadius: 'inherit',
						}
					}}
				>
					<Tab label={t('Loan Details')} />
					<Tab 
						className="tab-updates"
						label={
							<Badge
								badgeContent={loanNotes.length}
								color="error"
							>
								{t("Updates")}
							</Badge>
						}
						icon={<NotificationsIcon />}
						iconPosition="start"
					/>
					{(loanDetails.AccessDocs === '1') &&
						<Tab label={t('Documents')} />
					}
					{/* { <Tab label={t('Property Search')}/> } */}
				</Tabs>

				<Box sx={{ marginTop: '12px' }}>
					{value === 0 && <LoansDetails loanDetails={loanDetails} />}
					{value === 1 && <Updates loanNotes={loanNotes} />}
					{(value === 2 && loanDetails.AccessDocs === '1') &&
						<Documents
							loansDocumentsData={loansDocuments}
							loanStatus={loanDetails.StatusId}
							status={status}
							loanId={id}
						/>
					}
					{value === 3 &&
						<PropertySearch
							searchQuestionnaire={questionnaire}
							loanId={id}
						/>
					}
				</Box>
			</Box>

		</Box>
	)
};

export default withPermissionHOC(Details, ['access_loan_details'])
